import { MoreVertical } from "lucide-react";

export const CMSTable = ({
  columns = [],
  data = [],
  loading = false,
  emptyMessage = "No items found",
  onActionClick,
  onRowClick,
  openDropdown,
  setOpenDropdown,
  actions = [],
  renderCell,
}) => {
  return (
    <div className="z-0 w-full">
      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
        </div>
      ) : (
        <div className=" z-0">
          <table className="w-full border-none">
            <thead className="bg-gray-50 border-b">
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className={`px-2 h-9 text-sm font-semibold text-gray-700 uppercase tracking-wider ${
                      column.align === "center"
                        ? "text-center"
                        : column.align === "right"
                          ? "text-right"
                          : "text-left"
                    }`}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {data.length === 0 ? (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="px-2 py-3 h-14 text-center"
                  >
                    <p className="text-gray-500 text-[14px]">{emptyMessage}</p>
                  </td>
                </tr>
              ) : (
                data.map((item, rowIndex) => (
                  <tr
                    key={item.id || rowIndex}
                    className="hover:bg-gray-100 bg-gray-50 transition-colors cursor-pointer"
                    onClick={() => onRowClick && onRowClick(item)}
                  >
                    {columns.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={`px-2 py-3 h-14 ${
                          column.align === "center"
                            ? "text-center"
                            : column.align === "right"
                              ? "text-right"
                              : "text-left"
                        }`}
                        onClick={(e) => {
                          if (column.key === "actions") {
                            e.stopPropagation();
                          }
                        }}
                      >
                        {column.key === "actions" ? (
                          <div className="relative inline-block">
                            <button
                              onClick={() =>
                                setOpenDropdown(
                                  openDropdown === item.id ? null : item.id,
                                )
                              }
                              className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                            >
                              <MoreVertical
                                size={20}
                                className="text-gray-600"
                              />
                            </button>

                            {openDropdown === item.id && (
                              <>
                                <div
                                  className="fixed inset-0 z-10"
                                  onClick={() => setOpenDropdown(null)}
                                ></div>
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border z-50">
                                  <div className="py-1">
                                    {actions
                                      .filter(
                                        (action) =>
                                          !action.condition ||
                                          action.condition(item),
                                      )
                                      .map((action, actionIndex) => (
                                        <button
                                          key={actionIndex}
                                          onClick={() =>
                                            onActionClick(action.key, item)
                                          }
                                          className={`w-full text-left px-4 py-2 text-[14px] hover:bg-gray-100 flex items-center gap-2 ${
                                            action.variant === "danger"
                                              ? "text-red-600 hover:bg-red-50"
                                              : action.variant === "warning"
                                                ? "text-orange-600 hover:bg-orange-50"
                                                : "text-gray-700"
                                          }`}
                                        >
                                          {typeof action.label === "function"
                                            ? action.label(item)
                                            : action.label}
                                        </button>
                                      ))}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ) : renderCell ? (
                          renderCell(column.key, item)
                        ) : (
                          <div className="text-[14px] text-gray-900">
                            {item[column.key]}
                          </div>
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
